// extracted by mini-css-extract-plugin
export default {"container":"style_container__-RuNd","icon":"style_icon__p-ToO"};